import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { art, locks, resetParam, setParam, toggleLock } from "../state/params.svelte";
import { GROUPS, SPECS } from "../state/schema";
import ActionBar from "./ActionBar.svelte";
import PresetPicker from "./PresetPicker.svelte";
import Section from "./Section.svelte";
import PalettePicker from "./controls/PalettePicker.svelte";
import Select from "./controls/Select.svelte";
import Slider from "./controls/Slider.svelte";

var root = $.from_svg(`<path d="M3.5 5V3.5a2.5 2.5 0 0 1 5 0V5" fill="none" stroke="currentColor" stroke-width="1.3"></path>`);
var root_1 = $.from_svg(`<path d="M3.5 5V3.5a2.5 2.5 0 0 1 4.9-.6" fill="none" stroke="currentColor" stroke-width="1.3"></path>`);
var root_2 = $.from_html(`<div><button class="lock svelte-3byau3nx7hqfg"><svg width="11" height="11" viewBox="0 0 12 12" aria-hidden="true"><!><rect x="2.4" y="5" width="7.2" height="5.6" rx="1.1" fill="currentColor"></rect></svg></button> <div class="control svelte-3byau3nx7hqfg"><!></div></div>`);
var root_3 = $.from_html(`<button class="scrim svelte-3byau3nx7hqfg" aria-label="Close controls"></button> <aside class="panel svelte-3byau3nx7hqfg" aria-label="Controls"><!> <!> <!></aside>`, 1);
var root_4 = $.from_html(`<button class="fab svelte-3byau3nx7hqfg" aria-label="Show controls"><svg width="18" height="18" viewBox="0 0 16 16" aria-hidden="true"><g stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><line x1="2.5" y1="4.5" x2="13.5" y2="4.5"></line><line x1="2.5" y1="11.5" x2="13.5" y2="11.5"></line></g><circle cx="10" cy="4.5" r="2" fill="currentColor"></circle><circle cx="6" cy="11.5" r="2" fill="currentColor"></circle></svg></button>`);

export default function ControlPanel($$anchor, $$props) {
	$.push($$props, true);

	// v2: plot-model groups (Particles → Strands, Strands first) — the bump
	// discards stale stored section state that would hide the new group.
	const STORAGE_KEY = "eigenvisuals.sections.v2";

	const isMobile = typeof matchMedia !== "undefined" && matchMedia("(max-width: 719px)").matches;

	function loadOpen() {
		if (isMobile) {
			// Bottom sheet: everything collapsed except the preset row.
			return {
				Strands: false,
				Field: false,
				Motion: false,
				Appearance: false
			};
		}

		const fallback = { Strands: true, Field: false, Motion: false, Appearance: true };

		try {
			const raw = localStorage.getItem(STORAGE_KEY);

			if (raw) return { ...fallback, ...JSON.parse(raw) };
		} catch {
			/* storage unavailable (private mode) — use defaults */
		}

		return fallback;
	}

	const open = $.proxy(loadOpen());

	function toggleSection(group) {
		open[group] = !open[group];

		if (isMobile) return; // don't let sheet toggles overwrite desktop layout

		try {
			localStorage.setItem(STORAGE_KEY, JSON.stringify(open));
		} catch {
			/* ignore */
		}
	}

	function update(key, value) {
		setParam(key, value);
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_3 = ($$anchor) => {
			var fragment_1 = root_3();
			var button = $.first_child(fragment_1);
			var aside = $.sibling(button, 2);
			var node_1 = $.child(aside);

			PresetPicker(node_1, {});

			var node_2 = $.sibling(node_1, 2);

			$.each(node_2, 16, () => GROUPS, (group) => group, ($$anchor, group) => {
				{
					let $0 = $.derived(() => open[group] ?? false);

					Section($$anchor, {
						get label() {
							return group;
						},

						get open() {
							return $.get($0);
						},
						ontoggle: () => toggleSection(group),
						children: ($$anchor, $$slotProps) => {
							var fragment_3 = $.comment();
							var node_3 = $.first_child(fragment_3);

							$.each(node_3, 17, () => SPECS.filter((s) => s.group === group), (spec) => spec.key, ($$anchor, spec) => {
								var div = root_2();
								let classes;
								var button_1 = $.child(div);
								var svg = $.child(button_1);
								var node_4 = $.child(svg);

								{
									var consequent = ($$anchor) => {
										var path = root();

										$.append($$anchor, path);
									};

									var alternate = ($$anchor) => {
										var path_1 = root_1();

										$.append($$anchor, path_1);
									};

									$.if(node_4, ($$render) => {
										if (locks[$.get(spec).key]) $$render(consequent); else $$render(alternate, -1);
									});
								}

								$.next();
								$.reset(svg);
								$.reset(button_1);

								var div_1 = $.sibling(button_1, 2);
								var node_5 = $.child(div_1);

								{
									var consequent_1 = ($$anchor) => {
										Slider($$anchor, {
											get spec() {
												return $.get(spec);
											},

											get value() {
												return art.params[$.get(spec).key];
											},
											onchange: (v) => update($.get(spec).key, v),
											onreset: () => resetParam($.get(spec).key)
										});
									};

									var consequent_2 = ($$anchor) => {
										{
											let $0 = $.derived(() => String(art.params[$.get(spec).key]));

											Select($$anchor, {
												get spec() {
													return $.get(spec);
												},

												get value() {
													return $.get($0);
												},
												onchange: (v) => update($.get(spec).key, v)
											});
										}
									};

									var alternate_1 = ($$anchor) => {
										PalettePicker($$anchor, {
											get value() {
												return art.params.palette;
											},
											onchange: (v) => update("palette", v)
										});
									};

									$.if(node_5, ($$render) => {
										if ($.get(spec).kind === "range") $$render(consequent_1); else if ($.get(spec).kind === "select") $$render(consequent_2, 1); else $$render(alternate_1, -1);
									});
								}

								$.reset(div_1);
								$.reset(div);

								$.template_effect(() => {
									classes = $.set_class(div, 1, 'row svelte-3byau3nx7hqfg', null, classes, { locked: locks[$.get(spec).key] });
									$.set_attribute(button_1, 'aria-pressed', !!locks[$.get(spec).key]);

									$.set_attribute(button_1, 'title', locks[$.get(spec).key]
										? `${$.get(spec).label}: locked — Shuffle keeps it`
										: `${$.get(spec).label}: unlocked — Shuffle may change it`);
								});

								$.delegated('click', button_1, () => toggleLock($.get(spec).key));
								$.append($$anchor, div);
							});

							$.append($$anchor, fragment_3);
						},
						$$slots: { default: true }
					});
				}
			});

			var node_6 = $.sibling(node_2, 2);

			ActionBar(node_6, {});
			$.reset(aside);
			$.delegated('click', button, () => art.panelOpen = false);
			$.append($$anchor, fragment_1);
		};

		var alternate_2 = ($$anchor) => {
			var button_2 = root_4();

			$.delegated('click', button_2, () => art.panelOpen = true);
			$.append($$anchor, button_2);
		};

		$.if(node, ($$render) => {
			if (art.panelOpen) $$render(consequent_3); else $$render(alternate_2, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

$.delegate(['click']);
import "bun-svelte:ControlPanel.svelte-uwffsj74g36l-style.css";